"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identifyToFullStory = void 0;
var _1 = require(".");
exports.identifyToFullStory = function (id, userVars) {
    if (!_1.isFullStoryInstalled()) {
        return; // bail silently, we don't want to throw an error here
    }
    _1.getFullStory().identify(id, userVars);
};
